const BASE_URL = process.env.REACT_APP_BACKEND_URL;

export class AdminService {
    static async triggerSync(
        getAccessTokenSilently: () => Promise<string>
    ): Promise<string> {
        const accessToken = await getAccessTokenSilently();

        const response = await fetch(`${BASE_URL}/api/admin/sync`, {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${accessToken}`,
            },
        });

        if (!response.ok) {
            if (response.status === 403) {
                throw new Error("Accès refusé");
            }
            throw new Error(`Erreur HTTP : ${response.status}`);
        }

        return response.text();
    }
}
